import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { createNps, getNpsFormBySlug } from "../../apis/nps";
import { RENDER_NPS_URL_PREFIX } from "../../constants/forms.constants";
import { createNpsSurveyCreator } from "../../utils/forms.functions";
import DesignerLayout from "../shared/DesignerLayout";
var NpsDesigner = function () {
    var config = useMemo(function () { return ({
        listPath: "/nps/list",
        urlPrefix: RENDER_NPS_URL_PREFIX,
        createApi: createNps,
        fetchApi: getNpsFormBySlug,
        createCreator: createNpsSurveyCreator,
        defaultAuthRequired: false,
    }); }, []);
    return _jsx(DesignerLayout, { config: config });
};
export default NpsDesigner;
